import moment from 'moment-business-days'
import router from '@/router'
import * as ROUNDS_API from '@/constants/roundsApiEndpoints'

const SYNC_FREQUENCY = 60; // Measured in seconds

// Sync Service Plugin
class SyncService {
  constructor (Vue) {
    this.Vue = Vue;
    this._store = Vue.syncStore;

    // Attempt a sync on initialization, just in case any older reports are still stuck in the sync queue
    this.sync();

    // Setup timer to attempt a sync every SYNC_FREQUENCY seconds
    this.syncTimer = setInterval(() => { this.sync() }, SYNC_FREQUENCY * 1000);
  }

  add (data) {
    // Generate hashed value to use as item ID
    var timestamp = Date.now();
    var itemId = [
      data.roomId,
      data.userId,
      timestamp
    ].join('|');

    // TODO: Update property names to match back-end
    var item = {
      report_id: itemId,
      room_id: data.roomId,
      room: data.room,
      label: data.label,
      timestamp: timestamp,
      date_only_timestamp: moment(timestamp, 'x').format(),
      lastSent: null,
      status: 'pending',
      report_author: data.userId,
      report_author_user: data.user,
      report_sender: null,
      formData: data.form,
      teamId: data.teamId
    };

    this._store.dispatch('enqueue', { item });
    // TODO: Update room in room store to set last_checked to item.added

    // Log event in Google Analytics
    this.Vue.$ga.event({
      eventCategory: 'report',
      eventAction: 'submit' + data.roomStatus, // TODO: Should we differentiate between submit-working and submit-broken?
      eventLabel: item.label,
      eventValue: item.report_id
    });

    // Attempt to sync any items in queue
    this.sync(item);
  }

  get items () {
    return this._store.state.SyncQueue.queue;
  }

  sync (syncItem = false) {
    if (this.Vue.$auth.watch.authenticated) {
      /* Commenting out for now, isOnline doesn't compile down to ES5 correctly in build process
      isOnline().then(online => {
        // online var returns true or false
        if (online) {
          if (syncItem) {
            this.sendItem(syncItem);
          } else if (this.items) {
            var itemsToSend = this.items.filter(it => it.status !== 'sending');
            if (itemsToSend) {
              for (let item of itemsToSend) {
                this.sendItem(item);
              }
            }
          }
        } else if (syncItem || this.items) {
          // this.Vue.eventService.$emit('flashMessage', {
          //   text: 'No internet connection available. Reports will attempt to send again shortly.',
          //   type: 'error'
          // });
        }
      }).catch((errOnline) => {
        console.log(errOnline);
      })
      */
      if (syncItem) {
        this.sendItem(syncItem);
      } else if (this.items) {
        var itemsToSend = this.items.filter(it => it.status !== 'sending');
        if (itemsToSend) {
          for (let item of itemsToSend) {
            this.sendItem(item);
          }
        }
      }
    }
  }

  sendItem (item) {
    // If item is already being sent, don't send it again
    if (item.status === 'sending') {
      return;
    }
    item.status = 'sending';
    item.lastSent = Date.now();
    item.report_sender = this.Vue.$auth.user().uid;
    this._store.dispatch('updateItem', { item });

    const options = {
      credentials: true,
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        teamId: item.teamId
      }
    };
    const body = {
      report: item
    };
    this.Vue.http.post(ROUNDS_API['API_ENDPOINT_REPORT'], body, options).then(res => res.json()).then(
      // Success Calback
      response => {
        if (!response || response.errorMessage) {
          // Error Callback
          // TODO: Need to react to failure
          this.sendItemFailureCallback(item, response);
        } else {
          this.sendItemSuccessCallback(item, response);
        }
      },

      // Error Callback
      response => {
        this.sendItemFailureCallback(item, response);
      }
    ).catch(err => {
      console.log(err);
    })
  }

  sendItemSuccessCallback (item, response) {
    item.status = 'success';

    // Only trigger notification if item belongs to current team
    if (item.teamId === this.Vue.$teamService.currentTeamId) {
      this.Vue.eventService.$emit('flashMessage', {
        text: 'Report for ' + item.label + ' was successfully sent.',
        type: 'success'
      }); // TODO: Batch messages together if multiple succeed
    }
    this._store.dispatch('dequeue', { item });
  }

  sendItemFailureCallback (item, response) {
    item.status = 'failed';
    item.report_sender = null;

    // Only trigger notification if item belongs to current team
    if (!item.failureNotified && item.teamId === this.Vue.$teamService.currentTeamId) {
      this.Vue.eventService.$emit('flashMessage', {
        text: 'Report for ' + item.label + ' failed to submit. Details of your report have been saved and admins have been notified; no more action is needed on your part.',
        type: 'error'
      }); // TODO: Batch messages together if multiple fail
      item.failureNotified = true;
    }

    this._store.dispatch('dequeue', { item });

    // Log exception in Google Analytics
    if (response && (response.length || Object.keys(response).length)) {
      const exception = response.errorMessage || response;
      this.Vue.$ga.exception(exception);
    }

    // Log user out if request authorization fails
    if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
      this.Vue.$auth.logout().then(router.accessDenied);
    }
  }

  reset () {
    this._store.dispatch('clearQueue');
  }
}

const syncService = {
  install: function (Vue, options) {
    Vue.prototype.$syncService = new SyncService(Vue);
  }
};

export default syncService;



// WEBPACK FOOTER //
// ./src/services/SyncService.js